document.addEventListener('DOMContentLoaded', function () {
  //Product Gallery
  if (document.querySelectorAll('.product-imageslide .swiper-slide').length > 0) {
    document.querySelectorAll('.gallery-top').forEach((item) => {
      const sliderThumbs = new Swiper(item.nextElementSibling.firstElementChild, {
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 10,
        mousewheel: true,
        freeMode: true,
        breakpoints: {
          0: {
            direction: 'horizontal',
          },
          769: {
            direction: 'vertical',
          },
        },
      })
      const sliderImages = new Swiper(item, {
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 1000,
        mousewheel: false,
        grabCursor: true,
        thumbs: {
          swiper: sliderThumbs,
        },
        navigation: {
          nextEl: item.querySelector('.slider-btn--next'),
          prevEl: item.querySelector('.slider-btn--prev'),
        },
        pagination: {
          el: item.querySelector('.swiper-pagination'),
          clickable: true,
          type: 'progressbar',
        },
        breakpoints: {
          0: {
            direction: 'horizontal',
            mousewheel: false,
          },
          769: {
            direction: 'vertical'
          },
        },
      })
    })
  }


})

  



class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    //include Product Slider
    // productSliderupdate(this.currentVariant.featured_media.id)
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton) return
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateVariantInput() {
    console.log('updateVariantInput');
    const productForms = document.querySelectorAll(`#product-form-installment`)
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage() {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        const id = `price-${this.dataset.section}`

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')

        // this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`)
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"]')
    //inventory
    let stockCounter = ''
    if (document.querySelectorAll('.js-stock-counter').length > 0) {
      stockCounter = document.querySelector('.js-stock-number')
    }

    let inventoryHtml = ''
    if (this.currentVariant != undefined) {
      inventoryHtml = `${variantStock[this.currentVariant.id][0]}`
    }

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')

      if (text) addButtonText.textContent = text
      //inventory
      addButton.dataset.inventory = ''
      if (document.querySelectorAll('.js-stock-counter').length > 0) {
        stockCounter.innerHTML = ''
        if (this.currentVariant != undefined) {
          if (!this.currentVariant.available) {
            stockCounter.nextElementSibling.innerHTML = stockCounter.parentNode.dataset.outstock
            stockCounter.parentNode.classList.add('out-of-stock')
            stockCounter.parentNode.classList.remove('item-left')
            stockCounter.parentNode.classList.remove('in-stock')
          }
        }
      }

      //show disable radio select
      document.querySelectorAll('.js-radio-variant').forEach((item) => {
        if (item.checked === true) {
          item.classList.add('disabled')
        }
      })
    } else {
      addButton.removeAttribute('disabled')
      //remove disable radio select
      document.querySelectorAll('.js-radio-variant').forEach((item) => {
        item.classList.remove('disabled')
      })
      addButtonText.textContent = window.variantStrings.addToCart
      //inventory
      if (
        variantStock[this.currentVariant.id][0] > 0 &&
        variantStock[this.currentVariant.id][1] === 'deny' &&
        variantStock[this.currentVariant.id][2] === 'shopify'
      ) {
        addButton.dataset.inventory = inventoryHtml
      }
      if (document.querySelectorAll('.js-stock-counter').length > 0) {
        //if track swich on
        if (
          variantStock[this.currentVariant.id][0] > 0 &&
          variantStock[this.currentVariant.id][1] === 'deny' &&
          variantStock[this.currentVariant.id][2] === 'shopify'
        ) {
          stockCounter.innerHTML = inventoryHtml
          stockCounter.nextElementSibling.innerHTML = stockCounter.parentNode.dataset.itemleft
          stockCounter.parentNode.classList.remove('out-of-stock')
          stockCounter.parentNode.classList.remove('in-stock')
          stockCounter.parentNode.classList.add('item-left')
        }
        //if track swich off
        if (variantStock[this.currentVariant.id][1] === 'deny' && variantStock[this.currentVariant.id][2] == '') {
          stockCounter.innerHTML = ''
          stockCounter.nextElementSibling.innerHTML = stockCounter.parentNode.dataset.instock
          stockCounter.parentNode.classList.remove('out-of-stock')
          stockCounter.parentNode.classList.remove('item-left')
          stockCounter.parentNode.classList.add('in-stock')
        }
        //if track swich on and checked continue
        if (
          variantStock[this.currentVariant.id][1] === 'continue' &&
          variantStock[this.currentVariant.id][2] === 'shopify'
        ) {
          stockCounter.innerHTML = ''
          stockCounter.nextElementSibling.innerHTML = stockCounter.parentNode.dataset.instock
          stockCounter.parentNode.classList.remove('out-of-stock')
          stockCounter.parentNode.classList.remove('item-left')
          stockCounter.parentNode.classList.add('in-stock')
        }
      }
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`)
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"]')
    const price = document.getElementById(`price-${this.dataset.section}`)
    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
    })
  }
}
customElements.define('variant-radios', VariantRadios)

//Load Product Page and check current varian product image
function updateId() {
  //Radio
  if (document.querySelectorAll('variant-radios').length === 1) {
    document.querySelectorAll('.js-radio-variant').forEach((variant) => {
      if (variant.checked) {
        variant.parentNode.closest('.option-grid').previousElementSibling.lastChild.textContent = variant.value
      }
      variant.addEventListener('click', function () {
        this.parentNode.closest('.option-grid').previousElementSibling.lastChild.textContent =
          this.parentNode.dataset.name
      })
    })
  }
  //Select
  if (document.querySelectorAll('variant-selects').length === 1) {
    document.querySelectorAll('.option-variant').forEach((variant) => {
      if (variant.selected) {
        variant.parentNode.closest('.select').previousElementSibling.lastChild.previousSibling.textContent =
          variant.value
      }
    })
    document.querySelectorAll('.select__select').forEach((variant) => {
      variant.addEventListener('change', function () {
        variant.parentNode.closest('.select').previousElementSibling.lastChild.previousSibling.textContent = this.value
      })
    })
  }
  //Radio
  if (document.querySelectorAll('#radiojson').length === 1) {
    this.variantData = this.variantData || JSON.parse(document.querySelector('#radiojson').textContent)
    var varData = this.variantData || JSON.parse(document.querySelector('#radiojson').textContent)

    this.currentVariant = this.variantData.find((variant, index) => {
      if (
        variant.id == document.querySelector('.js-radio-variant[data-id]').dataset.id &&
        variant.featured_image != null
      ) {

      }
    })
    let variable = this.variantData.find((variant, index) => index === 0 && variant.available === false)
    if (!document.querySelector('.js-radio-variant[data-id]').dataset.id && variable) {
      this.variantData.find((variant, index) => {
        if (variant.available === true && index === 1) {
          if (variant.featured_image != null) {
            // productSliderupdate(variant.featured_media.id)
          }
        }
      })
    }
    //Not avaliable radio
    this.variantData = this.variantData.find((variant) => {
      if (variant.available === false) {
        document.querySelectorAll('.js-radio-variant').forEach((item) => {
          if (variant.title === item.value) {
            item.classList.add('novaliable')
          }
        })
      }
    })
  }
  //Select
  if (document.querySelectorAll('#selectjson').length === 1) {
    this.variantData = this.variantData || JSON.parse(document.querySelector('#selectjson').textContent)

    this.currentVariant = this.variantData.find((variant, index) => {
      if (
        variant.id == document.querySelector('.option-variant[data-id]').dataset.id &&
        variant.featured_image != null
      ) {
        //load page choose current image slide
        setTimeout(function () {
          // productSliderupdate(variant.featured_media.id)
        }, 300)
      }
    })
    let variable = this.variantData.find((variant, index) => index === 0 && variant.available === false)
    if (!document.querySelector('.option-variant[data-id]').dataset.id && variable) {
      this.variantData.find((variant, index) => {
        if (variant.available === true && index === 1) {
          // productSliderupdate(variant.featured_media.id)
        }
      })
    }

    this.variantData = this.variantData.find((variant) => {
      if (variant.available === false) {
        document.querySelectorAll('.option-variant').forEach((item) => {
          if (variant.title === item.value) {
            item.classList.add('novaliable')
          }
        })
      }
    })
  }

  //Chek if is current variant avaliable
  if (document.querySelectorAll('input.js-radio-variant').length > 0) {
    if(document.querySelector('.product-form__submit')) {
          if (document.querySelector('.product-form__submit').disabled === true) {
      //show disable radio select
      document.querySelectorAll('.js-radio-variant').forEach((item) => {
        if (item.checked === true) {
          item.classList.add('disabled')
        }
      })
    }
    }

  }
}
updateId()

